import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import TutorialStore from '../../stores/TutorialStore';
import StickyHeader from '../../components/tutorial/StickyHeader';
import MetaTags from '../../components/common/MetaTags';

@connectToStores
export default class GameTutorialDetailView extends React.Component {
    static propTypes = {
        tutorialStore: PropTypes.object //eslint-disable-line
    };
    static getStores() {
        return [TutorialStore];
    }

    static getPropsFromStores() {
        return {
            tutorialStore: TutorialStore.getState()
        };
    }

    

    render() {
        const pageData = this.props.tutorialStore.tutorialDetail || {};
        const {_title, utTutorial = {}} = pageData;
        const {introductionContent, title} = utTutorial;
        return (
            <div className="game-tutorial-detail-view">
                <MetaTags meta={{title: _title}} />
                <StickyHeader title={title} backUrl="/tutorials-how-to-play-ut" />
                <div className="game-tutorial-content" dangerouslySetInnerHTML={{__html: introductionContent}} />
            </div>
        );
    }
}
